// extracted by mini-css-extract-plugin
module.exports = {"bg":"BackgroundVideo_bg__zPXxV","current":"BackgroundVideo_current__1sPgf","loaded":"BackgroundVideo_loaded__1KCtV"};